import { call, put, takeEvery, all, fork } from "redux-saga/effects";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import {
  GET_CIVILBUDGETCONTROL,
  DELETE_CIVILBUDGETCONTROL,
  UPDATE_CIVILBUDGETCONTROL,
  ADD_NEW_CIVILBUDGETCONTROL,
} from "./actionType";

import {
  getCivilBudgetControlSuccess,
  getCivilBudgetControlFail,
  deleteCivilBudgetControlSuccess,
  deleteCivilBudgetControlFail,
  updateCivilBudgetControlSuccess,
  updateCivilBudgetControlFail,
  addCivilBudgetControlSuccess,
  addCivilBudgetControlFail,
} from "./action";

//Include Both Helper File with needed methods
import {
  getCivilBudgetControlApi,
  updateCivilBudgetControlApi,
  deleteCivilBudgetControlApi,
  addNewCivilBudgetControlApi,
  approveCivilBudgetControlApi
} from "../../helpers/backend_helper";

function* getCivilBudgetControl({ payload: civilBudgetControl }) {
  try {
    const response = yield call(getCivilBudgetControlApi, civilBudgetControl);
    yield put(getCivilBudgetControlSuccess(GET_CIVILBUDGETCONTROL, response.data));
  } catch (error) {
    yield put(getCivilBudgetControlFail(GET_CIVILBUDGETCONTROL, error));
  }
}

function* onUpdateCivilBudgetControl({ payload: civilBudgetControl }) {
  try {
    if (civilBudgetControl.setApprove) {
      const response = yield call(approveCivilBudgetControlApi, civilBudgetControl);
      yield put(updateCivilBudgetControlSuccess(response));
      toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
    }
    else {
      const response = yield call(updateCivilBudgetControlApi, civilBudgetControl);
      yield put(updateCivilBudgetControlSuccess(response));
      toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
    }
  } catch (error) {
    yield put(updateCivilBudgetControlFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onDeleteCivilBudgetControl({ payload: civilBudgetControl }) {
  try {
    const response = yield call(deleteCivilBudgetControlApi, civilBudgetControl);
    yield put(deleteCivilBudgetControlSuccess({ civilBudgetControl, ...response }));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(deleteCivilBudgetControlFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onAddNewCivilBudgetControl({ payload: civilBudgetControl }) {
  try {
    const response = yield call(addNewCivilBudgetControlApi, civilBudgetControl);
    yield put(addCivilBudgetControlSuccess(response));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(addCivilBudgetControlFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }

}

export function* watchGetCivilBudgetControl() {
  yield takeEvery(GET_CIVILBUDGETCONTROL, getCivilBudgetControl);
}

export function* watchUpdateCivilBudgetControl() {
  yield takeEvery(UPDATE_CIVILBUDGETCONTROL, onUpdateCivilBudgetControl);
}

export function* watchDeleteCivilBudgetControl() {
  yield takeEvery(DELETE_CIVILBUDGETCONTROL, onDeleteCivilBudgetControl);
}

export function* watchAddNewCivilBudgetControl() {
  yield takeEvery(ADD_NEW_CIVILBUDGETCONTROL, onAddNewCivilBudgetControl);
}

function* civilBudgetControlSaga() {
  yield all([
    fork(watchGetCivilBudgetControl),
    fork(watchDeleteCivilBudgetControl),
    fork(watchUpdateCivilBudgetControl),
    fork(watchAddNewCivilBudgetControl)
  ]);
}

export default civilBudgetControlSaga;
